<template>
  <div id="app">
    <!-- <header-message/> -->
    <router-view />
  </div>
</template>

<script>
import axios from 'axios'

// import HeaderMessage from '@/components/stateless/HeaderMessage'
const INPROGRESS_STATUS = 423
export default {
  created () {
    let _this = this
    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.response.status !== INPROGRESS_STATUS) {
          _this.$router.push({ name: 'signIn' })
        }
        throw err
      })
    })
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100vh;
  margin: 0;
}

#app {
  color: $black;
  font-family: 'Noto Sans', 'Roboto', Arial, sans-serif;
  background-color: #f5f7f7;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
